const logEvent = (payload) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
}

export default logEvent